import uuid from 'node-uuid';
import moment from 'moment';
import "./Tile";

/** @namespace GIS.Map.Layer */
NS("GIS.Map.Layer");

/**
 * @class
 * @extends GIS.Map.Layer.Tile
 */
GIS.Map.Layer.GlonassTile = Class(GIS.Map.Layer.Tile, /** @lends GIS.Map.Layer.GlonassTile.prototype */ {
    title: "ГЛОНАСС+112 тайлы",
    url: "//karta.tatar.ru/tilecache/{layerName}/{0z}/{x1}/{x2}/{x3}/{-y1}/{-y2}/{-y3}.{tileFormat}",
    attributions: ["Картографические данные © ГЛОНАСС+112, " + moment().format('YYYY')],
    minZoom: 5,
    maxZoom: 18,
    projection: 'EPSG:3857',
    /** @inheritDoc */
    initialize()
    {
        this.ParentCall();
        this.name = "GIS.Map.Layer.GlonassTile:" + uuid.v4();
    }
});
